import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {LoginCallback, Security} from '@okta/okta-react';
import {oktaAuthInstance} from './Auth';
import {createTheme, ThemeProvider} from '@mui/material/styles';

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.replace(originalUri || window.location.origin);
};

const theme = createTheme({
        palette: {
            primary: {
                main: 'rgba(0,0,0,0.87)',
                contrastText: '#fff',
            },
            secondary: {
                main: '#e0e0e0',
                contrastText: 'rgba(0,0,0,0.87)',
            },
        },
        components: {
            MuiButton: {
                variants: [
                    {
                        props: {variant: 'grey'},
                        style: {
                            backgroundColor: '#e0e0e0',
                            color: 'rgba(0,0,0,0.87)',
                            boxShadow:
                                '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                            '&:hover': {
                                backgroundColor: '#d5d5d5',
                                boxShadow:
                                    '0px 4px 2px -2px rgba(0,0,0,0.2), 0px 3px 3px 0px rgba(0,0,0,0.14), 0px 2px 6px 0px rgba(0,0,0,0.12)',
                            },
                        },
                    },
                ],
            },
            MuiSelect: {
                defaultProps: {
                    variant: 'standard',
                },
            },
            MuiTextField: {
                defaultProps: {
                    variant: 'standard',
                }
            }
        },
        typography: {
            fontFamily: 'GucciSans-Book',
        }
    }
);

const isLoginCallback = window.location.search.includes('code=');

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Security oktaAuth={oktaAuthInstance} restoreOriginalUri={restoreOriginalUri}>
                {isLoginCallback ? <LoginCallback/> : <App/>}
            </Security>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
